import axios from "axios";
import "../config.js";

const getAccess = () => {
  var clientkeys = {};
  if (`${process.env.REACT_APP_DEVELOPMENT_ENV}` === "staging") {
    clientkeys = {
      client_name: `${process.env.REACT_APP_NAME_STAGING}`,
      client_secret: `${process.env.REACT_APP_CLIENT_SECRET_STAGING}`,
    };
  } else if (`${process.env.REACT_APP_DEVELOPMENT_ENV}` === "production") {
    clientkeys = {
      client_name: `${process.env.REACT_APP_NAME_PRODUCTION}`,
      client_secret: `${process.env.REACT_APP_CLIENT_SECRET_PRODUCTION}`,
    };
  }
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: `${window.livasaConfig.token}${window.livasaConfig.networkid}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(clientkeys),
    })
      .then((res) => {
        if (res.status !== 200) {
          return reject(res);
        }
        localStorage.setItem("token", res.data.access_token);
        return resolve(res.data.access_token);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

const getToken = () => {
  try {
    let data = localStorage.getItem("token");
    return data;
  } catch (e) {
    return e;
  }
};

const getCategoriesBasedOnParentId = () => {
  return new Promise(async (resolve, reject) => {
    try {
      let token = await getToken(); // Wait for token
      const res = await axios({
        method: "GET",
        url: `${window.livasaConfig.getCategories}${window.livasaConfig.networkid}/${window.livasaConfig.networkid}/${window.livasaConfig.user}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status !== 200) {
        reject(new Error("Failed to fetch categories"));
      } else {
        resolve(res.data.categoryList);
      }
    } catch (error) {
      reject(error);
    }
  });
};

const getAllUserofUserType = async (userType) => {
  return new Promise(async (resolve, reject) => {
    try {
      let token = await getToken();
      const url = `${window.livasaConfig.getAllusersofUserType}${window.livasaConfig.networkid}/${window.livasaConfig.networkid}/${userType}`;
      const res = await axios({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status !== 200) {
        reject();
      } else {
        resolve(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  });
};

const locationProvider = async (user, type) => {
  return new Promise(async (resolve, reject) => {
    try {
      let token = await getToken();
      const url = `https://proxystaging.gbrservice.com/EAP/getallsites/${window.livasaConfig.networkid}/${user}/${type}`;
      const res = await axios({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status !== 200) {
        reject(new Error("Failed to fetch location"));
      } else {
        resolve(res.data);
      }
    } catch (error) {
      reject(error);
    }
  });
};

// const locationProvider = async () => {
//   try {
//     let token = await getToken();
//     const url = "https://proxystaging.gbrservice.com/EAP/getallsites/consumer2/sapnahoney/Store";
//     const res = await axios.get(url, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     return res.data; // Return only the data if successful

//   } catch (error) {
//     throw new Error("Failed to fetch location: " + error.message); // Better error message
//   }
// };

const productModelBasedonSubcategory = (getCatId, Type, user) => {
  return new Promise(async (resolve, reject) => {
    try {
      let token = await getToken();
      const res = await axios({
        method: "GET",
        url: `${window.livasaConfig.modelBasedOnCategory}${window.livasaConfig.networkid}/${getCatId}/${Type}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          orgid: user,
          networkid: `${window.livasaConfig.networkid}`,
          username: user,
          suborgid: "",
        },
      });

      if (res.status !== 200) {
        return reject(res);
      }
      return resolve(res.data.products);
    } catch (error) {
      reject(error);
    }
  });
};

const productLikeCount = (product) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",

      url: `${window.livasaConfig.productLikeCount}${window.livasaConfig.networkid}/${product.consumeradminid}/${product.businessid}/${product.productid}`,

      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${getToken()}`,
        networkid: `${window.livasaConfig.networkid}`,
        orgid: `${product.businessid}`,
        suborgid: "",
        username: `${product.businessid}`,
      },
    })
      .then((res) => {
        if (res.status !== 200) {
          return reject(res.data);
        }
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

const getSubCategories = (username, catid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let token = await getToken();
      const res = await axios({
        method: "GET",
        url: `${window.livasaConfig.getSubCategories}${window.livasaConfig.networkid}/${window.livasaConfig.networkid}/contentSubCategories/${catid}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status !== 200) {
        return reject(res.data);
      }
      return resolve(res.data);
    } catch (error) {
      reject(error);
    }
  });
};

const getAllProductsofUser = (user, getCatId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let token = await getToken();
      const res = await axios({
        method: "GET",
        url: `${window.livasaConfig.getAllProducts}${window.livasaConfig.networkid}/${getCatId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          // orgid: user,
          // networkid: `${window.livasaConfig.networkid}`,
          // username: user,
          // suborgid: "",
        },
      });

      if (res.status !== 200) {
        return reject(res);
      }
      return resolve(res.data.products);
    } catch (error) {
      reject(error);
    }
  });
};

  // https://proxystaging.gbrservice.com/AgriProductProxy/allproducts/apischainsirealm/apischainsi/AGR15-100B


const getProductOfUser = (catId) =>{
  return new Promise(async(resolve, reject)=>{
    try{
      let token = await getToken();
      const res = await axios({
        method:"GET",
        url:`${window.livasaConfig.getAllProductsBasedonParentId}${window.livasaConfig.networkid}/${window.livasaConfig.user}/${catId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if(!res.status === 200){
        return reject(res)
      }

      return resolve(res)



    }catch(error){
      reject(error);
    }
  })
}


const sendRequest = async (data) => {
  try {
    const url = `${window.livasaConfig.registerUser}${window.livasaConfig.networkid}/${
      window.livasaConfig.clientId
    }/${window.livasaConfig.clientSecret}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      if (response.status === 409) {
        throw "Consumer user already exist.";
      }
      const errorData = await response.json();
      throw errorData;
    }

    const result = await response.json();
    return result;
  } catch (e) {
    if (typeof e === "string") {
      throw e; // already handled above
    } else {
      throw "Internal server error, please try again.";
    }
  }
};

export default {
  getAccess,
  getCategoriesBasedOnParentId,
  productModelBasedonSubcategory,
  productLikeCount,
  getSubCategories,
  locationProvider,
  getAllProductsofUser,
  getAllUserofUserType,
  getProductOfUser,
  sendRequest
};
